export const ITS_AUTO_LEN = 8;
export const ITS_AUTO_DEBOUNCE_MS = 400;
export const ITS_DATA_RESOURCE = "itsdata";

const COMPLETE_ITS_RE = new RegExp(`^\\d{${ITS_AUTO_LEN}}$`);

export function isCompleteItsId(value: unknown): boolean {
  return COMPLETE_ITS_RE.test(String(value ?? "").trim());
}

export function itsAutoDefaultHelperText(): string {
  return `Enter ${ITS_AUTO_LEN}-digit ITS; lookup runs automatically`;
}

export function normalizeItsQuery(value: unknown): string {
  return String(value ?? "").trim();
}

/** Shared getList params for button-triggered ITS searches (Lagat / hall bookings). */
export function buildItsButtonSearchParams(q: string) {
  return {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "id", order: "ASC" as const },
    filter: {
      q,
      includeFamily: true,
    },
  };
}

/** Shared getList params for auto-debounced ITS lookups (Raza). */
export function buildItsAutoLookupParams(q: string, extraFilter?: Record<string, unknown>) {
  return {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "ITS_ID", order: "ASC" as const },
    filter: {
      q,
      includeFamily: true,
      ...extraFilter,
    },
  };
}
